import {
  Create,
  email as emailValidator,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  TopToolbar,
  useNotify,
} from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start", p: "0 0 16px 16px" }}>
    <SaveButton label="Resend promo" />
  </TopToolbar>
);

export const ResendPromoPage = () => {
  const notify = useNotify();
  const onSuccess = () => {
    notify("Promo has been resent successfully", {
      type: "success",
    });
  };

  return (
    <Create
      resource={MODULE_NAMES.RESEND_PROMO}
      mutationOptions={{
        onSuccess,
      }}
    >
      <SimpleForm toolbar={<CreateActions />}>
        <TextInput
          source="email"
          label="Email"
          validate={[required(), emailValidator()]}
        />
      </SimpleForm>
    </Create>
  );
};
